
import React from 'react';
import '../styles/philanthropy.css';
import PanelCarousel from '../components/PanelCarousel';

const Philanthropy = () => {
  return (
    <div className="bg-gradient-light min-vh-100">
      {/* Main Philanthropy Section */}
      <section className="main-philanthropy py-5 mt-5">
        <div className="container">
          <div className="row align-items-center g-5">
            <div className="col-md-6 col-lg-6">
              <h2 className="section-header mb-4">
                <i className="fas fa-heart text-gold me-3"></i>
                Our Philanthropic Mission
              </h2>
              <div className="mission-content">
                <div className="julia-tribute mb-5">
                  <h3 className="h4 text-royal-purple mb-3">
                    <i className="fas fa-heart text-gold me-2"></i>
                    Remembering Julia C. Black
                  </h3>
                  <p className="mb-4">Julia C. Black was the beloved sister of one of our brothers, and her memory continues to inspire our chapter's commitment to service and community. At her high school, Julia embodied excellence in all she pursued, whether leading on the volleyball court, where her passion for the game shone brightly, or in her daily interactions with those around her.</p>
                  
                  <p className="mb-4">Those who knew Julia remember her as a remarkably kind-hearted and generous person, someone who brought light and warmth to every room she entered. Her spirit of compassion and her dedication to making a positive impact on others left an indelible mark on our chapter and the broader community.</p>
                </div>
                
                <div className="honoring-julia mb-4">
                  <p className="lead mb-4">Each spring, the brothers of SAE at Florida State University host <strong className="text-gold">Paddy Murphy Week</strong> in honor of the <strong className="text-gold">Julia C. Black Legacy Scholarship</strong>, created after Julia's passing in 2023. This annual tradition allows us to celebrate her life while supporting future generations of students who share her values of kindness, generosity, and excellence.</p>
                  
                  <div className="highlight-box mb-4">
                    <i className="fas fa-trophy text-gold me-2"></i>
                    <span>Thanks to the dedication of our brothers and the incredible efforts of our sweetheart candidates, we raised over <strong className="text-gold">$14,000</strong> through a week of events, all dedicated to continuing Julia's legacy.</span>
                  </div>
                  
                  <p className="mb-4">These funds go directly to a graduating high school senior who reflects the strength, spirit, and character that Julia embodied throughout her life.</p>
                </div>
                
                <p className="mb-4">Our commitment to service doesn't end with our own chapter. Each year, we proudly support <strong className="text-royal-purple">Panhellenic philanthropy competitions</strong>, with brothers raising funds for sorority-led causes across campus.</p>
                
                <div className="mission-quote">
                  <i className="fas fa-quote-left text-gold"></i>
                  <p className="fst-italic">Giving back is more than tradition — it's part of who we are.</p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-6">
              <h4 className="text-center text-royal-purple mb-3">
                <i className="fas fa-crown text-gold me-2"></i>
                Taylor Hicks
              </h4>
              <p className="text-center text-muted mb-4">2025 SAE Violet</p>
              <div className="image-container hover-lift">
                <img src="/images/JCB.jpg" alt="Taylor Hicks - 2025 SAE Violet" className="img-fluid rounded-3 shadow-lg" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Current Fundraising Section */}
      <section className="current-fundraising py-5 bg-gradient-light">
        <div className="container">
          <h2 className="section-header text-center mb-5">
            <i className="fas fa-hand-holding-heart text-gold me-3"></i>
            Current Philanthropy Events
          </h2>
          <div className="row g-4 justify-content-center">
            {/* Movember Month Card */}
            <div className="col-md-8 col-lg-6">
              <div className="fundraising-card card border-0 shadow-lg hover-lift">
                <div className="card-body p-5">
                  <div className="text-center mb-4">
                    <i className="fas fa-mustache fa-3x text-royal-purple mb-3"></i>
                    <h3 className="card-title h3 text-royal-purple mb-4">Movember Month</h3>
                    <div className="d-flex justify-content-center align-items-center mb-3">
                      <span className="badge bg-gold text-dark px-3 py-2 me-2">Men's Mental Health</span>
                      <span className="badge bg-royal-purple text-white px-3 py-2">No Shave November</span>
                    </div>
                  </div>
                  
                  <p className="card-text lead mb-4">Join SAE brothers in raising awareness for <strong className="text-royal-purple">men's mental health</strong> and supporting <strong className="text-gold">No Shave November</strong>. Together, we're breaking the silence and promoting mental wellness.</p>
                  
                  <div className="movember-highlights mb-4">
                    <div className="row text-center">
                      <div className="col-md-6 mb-3">
                        <div className="highlight-item">
                          <i className="fas fa-brain text-gold mb-2"></i>
                          <h6 className="text-royal-purple fw-bold mb-1">Mental Health</h6>
                          <p className="text-muted mb-0 small">Awareness & Support</p>
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <div className="highlight-item">
                          <i className="fas fa-cut text-gold mb-2"></i>
                          <h6 className="text-royal-purple fw-bold mb-1">No Shave</h6>
                          <p className="text-muted mb-0 small">November Challenge</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div className="cause-highlight mb-4">
                    <div className="highlight-box text-center">
                      <i className="fas fa-heart text-gold mb-2"></i>
                      <h6 className="text-royal-purple fw-bold mb-2">Movember Foundation</h6>
                      <p className="text-muted mb-0 small">Supporting men's health initiatives worldwide</p>
                    </div>
                  </div>
                  
                  <a 
                    href="https://us.movember.com/" 
                    className="btn btn-royal-purple btn-lg w-100" 
                    target="_blank" 
                    rel="noopener noreferrer"
                  >
                    <i className="fas fa-external-link-alt me-2"></i>
                    Learn More About Movember
                  </a>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Past Events Section */}
      <section className="past-events py-5">
        <div className="container">
          <h2 className="section-header text-center mb-5">
            <i className="fas fa-calendar-alt text-gold me-3"></i>
            Past Philanthropy Events
          </h2>
          
          {/* Delta Gamma Anchorsplash Competition Event */}
          <div className="row mb-5 align-items-center g-5">
            <div className="col-md-5 col-lg-4">
              <div className="event-image-container hover-lift">
                <img src="/images/Julius.JPG" alt="Julius Talas - Delta Gamma Anchorsplash Winner" className="img-fluid rounded-3 shadow-lg" />
                <div className="event-badge">
                  <span className="badge bg-gold text-dark px-3 py-2">2025</span>
                </div>
              </div>
            </div>
            <div className="col-md-7 col-lg-8">
              <div className="event-card card border-0 shadow-sm hover-lift">
                <div className="card-body p-4">
                  <div className="d-flex align-items-center mb-3">
                    <i className="fas fa-trophy text-gold me-2"></i>
                    <h3 className="h4 mb-0 text-royal-purple">Delta Gamma Anchorsplash Competition - 2025</h3>
                  </div>
                  
                  <p className="lead mb-3">Congratulations to our brother <strong className="text-royal-purple">Julius Talas</strong> for representing SAE in the Delta Gamma Anchorsplash competition! Julius won the <strong className="text-gold">Dance portion</strong> of the competition and raised <strong className="text-gold">$800</strong> for <strong className="text-gold">Service For Sight</strong>.</p>
                  
                  <div className="event-highlights mb-3">
                    <h6 className="text-royal-purple fw-bold mb-2">Competition Highlights:</h6>
                    <ul className="list-unstyled">
                      <li><i className="fas fa-trophy text-gold me-2"></i>Winner of the Dance Competition</li>
                      <li><i className="fas fa-dollar-sign text-gold me-2"></i>$800 raised for Service For Sight</li>
                      <li><i className="fas fa-eye text-gold me-2"></i>Benefiting individuals with visual impairments</li>
                    </ul>
                  </div>
                  
                  <div className="success-metric">
                    <div className="metric-card bg-gradient-light p-3 rounded">
                      <div className="row text-center">
                        <div className="col">
                          <h5 className="text-gold mb-1">$800</h5>
                          <small className="text-muted">Raised</small>
                        </div>
                        <div className="col">
                          <h5 className="text-royal-purple mb-1">1</h5>
                          <small className="text-muted">Competition Won</small>
                        </div>
                        <div className="col">
                          <h5 className="text-gold mb-1">1</h5>
                          <small className="text-muted">Week Competition</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Zeta King Competition Event */}
          <div className="row mb-5 align-items-center g-5">
            <div className="col-md-5 col-lg-4">
              <div className="event-image-container hover-lift">
                <img src="/images/Hallet.jpg" alt="Connor Hallett - Zeta King Competition" className="img-fluid rounded-3 shadow-lg" />
                <div className="event-badge">
                  <span className="badge bg-gold text-dark px-3 py-2">2025</span>
                </div>
              </div>
            </div>
            <div className="col-md-7 col-lg-8">
              <div className="event-card card border-0 shadow-sm hover-lift">
                <div className="card-body p-4">
                  <div className="d-flex align-items-center mb-3">
                    <i className="fas fa-ribbon text-gold me-2"></i>
                    <h3 className="h4 mb-0 text-royal-purple">Zeta King Competition - 2025</h3>
                  </div>
                  
                  <p className="lead mb-3">Our brother <strong className="text-royal-purple">Connor Hallett</strong> was nominated by the ladies of <strong className="text-royal-purple">Zeta Tau Alpha</strong> to represent SAE in their 2025 Zeta King competition. Throughout the competition, Connor worked alongside the ZTA sisters to raise <strong className="text-gold">$1,000</strong> for their national philanthropy, which focuses on <strong className="text-gold">breast cancer research and awareness</strong>.</p>
                  
                  <div className="event-highlights mb-3">
                    <h6 className="text-royal-purple fw-bold mb-2">Competition Highlights:</h6>
                    <ul className="list-unstyled">
                      <li><i className="fas fa-dollar-sign text-gold me-2"></i>$1,000 raised for breast cancer research and awareness</li>
                      <li><i className="fas fa-heart text-gold me-2"></i>Supporting Zeta Tau Alpha's national philanthropy</li>
                      <li><i className="fas fa-calendar-alt text-gold me-2"></i>Field Day on October 16th (5-7 PM)</li>
                      <li><i className="fas fa-running text-gold me-2"></i>Race To Live 5k on October 26th</li>
                    </ul>
                  </div>
                  
                  <div className="success-metric">
                    <div className="metric-card bg-gradient-light p-3 rounded">
                      <div className="row text-center">
                        <div className="col">
                          <h5 className="text-gold mb-1">$1,000</h5>
                          <small className="text-muted">Raised</small>
                        </div>
                        <div className="col">
                          <h5 className="text-royal-purple mb-1">ZTA</h5>
                          <small className="text-muted">Partner Organization</small>
                        </div>
                        <div className="col">
                          <h5 className="text-gold mb-1">Breast Cancer</h5>
                          <small className="text-muted">Cause Supported</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Mr. Casanova Competition Event */}
          <div className="row mb-5 align-items-center g-5">
            <div className="col-md-5 col-lg-4">
              <div className="event-image-container hover-lift">
                <img src="/images/yonce.jpg" alt="Payton Yonce - SAE Mr. Casanova Competitor" className="img-fluid rounded-3 shadow-lg" />
                <div className="event-badge">
                  <span className="badge bg-gold text-dark px-3 py-2">2025</span>
                </div>
              </div>
            </div>
            <div className="col-md-7 col-lg-8">
              <div className="event-card card border-0 shadow-sm hover-lift">
                <div className="card-body p-4">
                  <div className="d-flex align-items-center mb-3">
                    <i className="fas fa-heart text-gold me-2"></i>
                    <h3 className="h4 mb-0 text-royal-purple">Mr. Casanova Competition - 2025</h3>
                  </div>
                  
                  <p className="lead mb-3">Our brother <strong className="text-royal-purple">Payton Yonce</strong> represented SAE in the Kappa Alpha Theta Mr. Casanova competition, raising <strong className="text-gold">$4,000</strong> for the <strong className="text-gold">CASA Foundation</strong>.</p>
                  
                  <div className="event-highlights mb-3">
                    <h6 className="text-royal-purple fw-bold mb-2">Competition Highlights:</h6>
                    <ul className="list-unstyled">
                      <li><i className="fas fa-dollar-sign text-gold me-2"></i>$4,000 raised for CASA Foundation</li>
                      <li><i className="fas fa-heart text-gold me-2"></i>Benefiting Court Appointed Special Advocates for children in foster care</li>
                      <li><i className="fas fa-users text-gold me-2"></i>Representing SAE in campus-wide philanthropy competition</li>
                    </ul>
                  </div>
                  
                  <div className="success-metric">
                    <div className="metric-card bg-gradient-light p-3 rounded">
                      <div className="row text-center">
                        <div className="col">
                          <h5 className="text-gold mb-1">$4,000</h5>
                          <small className="text-muted">Raised</small>
                        </div>
                        <div className="col">
                          <h5 className="text-royal-purple mb-1">Kappa Alpha Theta</h5>
                          <small className="text-muted">Partner Organization</small>
                        </div>
                        <div className="col">
                          <h5 className="text-gold mb-1">CASA</h5>
                          <small className="text-muted">Foundation Supported</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Champs Chance Event */}
          <div className="row mb-5 align-items-center g-5">
            <div className="col-md-5 col-lg-4">
              <div className="event-image-container hover-lift">
                <img src="/images/ChampsChance.jpg" alt="Champs Chance Event 2025" className="img-fluid rounded-3 shadow-lg" />
                <div className="event-badge">
                  <span className="badge bg-gold text-dark px-3 py-2">2025</span>
                </div>
              </div>
            </div>
            <div className="col-md-7 col-lg-8">
              <div className="event-card card border-0 shadow-sm hover-lift">
                <div className="card-body p-4">
                  <div className="d-flex align-items-center mb-3">
                    <i className="fas fa-paw text-gold me-2"></i>
                    <h3 className="h4 mb-0 text-royal-purple">Champs Chance Event - 2025</h3>
                  </div>
                  
                  <p className="lead mb-3">We partnered with <strong className="text-royal-purple">Delta Gamma</strong> to host the Champs Chance event at our house. Brothers and sisters came together to meet the pups and support a day filled with fundraising for <strong className="text-gold">Champs Chance</strong>. Together, we raised <strong className="text-gold">$1,200</strong> for this important cause.</p>
                  
                  <div className="event-highlights mb-3">
                    <h6 className="text-royal-purple fw-bold mb-2">Event Details:</h6>
                    <ul className="list-unstyled">
                      <li><i className="fas fa-calendar-alt text-gold me-2"></i>Monday, October 13th, 2025</li>
                      <li><i className="fas fa-clock text-gold me-2"></i>3:00 PM - 5:30 PM</li>
                      <li><i className="fas fa-map-marker-alt text-gold me-2"></i>415 W College Ave</li>
                      <li><i className="fas fa-paw text-gold me-2"></i>Dog shelter foster event fundraiser</li>
                    </ul>
                  </div>
                  
                  <div className="success-metric">
                    <div className="metric-card bg-gradient-light p-3 rounded">
                      <div className="row text-center">
                        <div className="col">
                          <h5 className="text-gold mb-1">$1,200</h5>
                          <small className="text-muted">Raised</small>
                        </div>
                        <div className="col">
                          <h5 className="text-royal-purple mb-1">Delta Gamma</h5>
                          <small className="text-muted">Partner Organization</small>
                        </div>
                        <div className="col">
                          <h5 className="text-gold mb-1">1</h5>
                          <small className="text-muted">Day Event</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Paddy Murphy Week Event */}
          <div className="row mb-5 align-items-center g-5">
            <div className="col-md-5 col-lg-4">
              <div className="event-image-container hover-lift">
                <img src="/images/Paddy.jpg" alt="Paddy Murphy Week 2025" className="img-fluid rounded-3 shadow-lg" />
                <div className="event-badge">
                  <span className="badge bg-gold text-dark px-3 py-2">2025</span>
                </div>
              </div>
            </div>
            <div className="col-md-7 col-lg-8">
              <div className="event-card card border-0 shadow-sm hover-lift">
                <div className="card-body p-4">
                  <div className="d-flex align-items-center mb-3">
                    <i className="fas fa-star text-gold me-2"></i>
                    <h3 className="h4 mb-0 text-royal-purple">Paddy Murphy Week - 2025</h3>
                  </div>
                  
                  <p className="lead mb-3">This year's Paddy Murphy Week was one of the most successful in our chapter's history, raising over <strong className="text-gold">$14,000</strong> for the <strong className="text-gold">Julia C. Black Scholarship Fund</strong>.</p>
                  
                  <div className="event-highlights mb-3">
                    <h6 className="text-royal-purple fw-bold mb-2">Featured Events:</h6>
                    <ul className="list-unstyled">
                      <li><i className="fas fa-music text-gold me-2"></i>Semi-formal at Recess</li>
                      <li><i className="fas fa-dice text-gold me-2"></i>Brotherhood Poker Night</li>
                      <li><i className="fas fa-castle text-gold me-2"></i><em>"Darti Gras at the Castle"</em></li>
                    </ul>
                  </div>
                  
                  <div className="success-metric">
                    <div className="metric-card bg-gradient-light p-3 rounded">
                      <div className="row text-center">
                        <div className="col">
                          <h5 className="text-gold mb-1">$14,000+</h5>
                          <small className="text-muted">Raised</small>
                        </div>
                        <div className="col">
                          <h5 className="text-royal-purple mb-1">7</h5>
                          <small className="text-muted">Days of Events</small>
                        </div>
                        <div className="col">
                          <h5 className="text-gold mb-1">1</h5>
                          <small className="text-muted">Scholarship Created</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Panhellenic Competitions Section */}
      <section className="panhellenic-section py-5 bg-gradient-light">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="section-header mb-4">
              <i className="fas fa-users text-gold me-3"></i>
              2024-2025 Panhellenic Competitors
            </h2>
            <p className="lead text-muted">Our brothers proudly represent SAE in campus-wide philanthropy competitions</p>
          </div>
          <div className="carousel-container">
            <PanelCarousel />
          </div>
        </div>
      </section> 

      <footer className="bg-dark text-white py-4 text-center">
        <div className="container">
          <p className="mb-0">© 2025 Sigma Alpha Epsilon - Florida State University</p>
        </div>
      </footer>
    </div>
  );
};

export default Philanthropy;
